import classNames from "classnames";
import { PropsWithChildren, ReactElement } from "react";
import styles from "./FormLabel.module.less";

export type FieldsetLegendProps = {
	isRequired?: boolean;
	isEllipsed?: boolean;
	tooltip?: string;
};

export const FieldsetLegend = (props: PropsWithChildren<FieldsetLegendProps>): ReactElement => {
	const {
		isRequired,
		isEllipsed,
		tooltip,
		children
	} = props;

		return (
			<legend
				className={classNames(
					styles.root,
					{
						[styles.root_required]: isRequired,
						[styles.root_isEllipsed]: isEllipsed
					}
				)}
				title={tooltip}
			>
				{children}
			</legend>
		);
};
FieldsetLegend.displayName = "FieldsetLegend";